import { Component, OnInit } from '@angular/core';
import { JwtAuthService } from '../../../core/services/auth.service';

import { FormBuilder, FormGroup, Validators } from '@angular/forms';
// import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';


import { ActivatedRoute, Router } from '@angular/router';
import { first } from 'rxjs/operators';


import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})

/**
 * Login component
 */
export class LoginComponent implements OnInit {

  loginForm: FormGroup;
  submitted = false;
  error = '';
  returnUrl: string;
  userDetails: any;
  tab: Number;
  // set the currenr year
  year: number = new Date().getFullYear();
 

  constructor(private formBuilder: FormBuilder, private route: ActivatedRoute, private router: Router, private authService: JwtAuthService) { }

  // email: ['', [Validators.required, Validators.email]],
  ngOnInit() {
    this.loginForm = this.formBuilder.group({
      email: ['', [Validators.required]],
      password: ['', [Validators.required]]
    });

    this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/';

    this.route.queryParams.subscribe(params => {
      this.tab = +params['tab'];  // The + sign is to convert the string to a number
    });

  }


  // convenience getter for easy access to form fields
  get f() { return this.loginForm.controls; }

  /**
   * Form submit
   */
  onSubmit() {
    this.submitted = true;

    // stop here if form is invalid
    if (this.loginForm.invalid) {
      return;
    } else {
      
        this.authService.login(this.f.email.value, this.f.password.value)
        .pipe(first())
          .subscribe(
            data => {
              localStorage.setItem('token', data.token.access);
              console.log('Token saved successfully:', data.token.access);
              this.authService.getUserDetails().subscribe(
                userDetails => {
                    this.userDetails = userDetails;
                    if (this.userDetails.group_choice === 'customers'){
                      this.router.navigate(['/dashboard/booking']);
                    } else {
                      console.log('Navigating to dashboard');  
                      this.router.navigate(['/dashboard']);
                    }
                  },
                  error => {
                    console.log(error);
                    // Handle the error
                  }
                );
              
            },
            error => {
              console.log(error);
              this.error = error ? error : '';
            }
          );
      }
    }
  

}
